// Angular modules
import { Component }          from '@angular/core';

// Ionic modules
import { GoogleAnalytics }    from '@ionic-native/google-analytics';
import { MenuController }     from 'ionic-angular';
import { NavController }      from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';
import { ToastController }    from 'ionic-angular';
import { Platform }           from 'ionic-angular';

// External modules
import { Category }           from '../../shared/models/category';
import { Product }            from '../../shared/models/product';
import { ProductFamily }      from '../../shared/models/productFamily';
import { Translation }        from '../../shared/models/translation';
import { ApplicationService } from '../../shared/providers/application-service';
import { LangService }        from '../../shared/providers/lang-service';
import { ProductDetailPage }  from '../product-detail/product-detail';
import { TranslateService }   from '@ngx-translate/core';
import _                      from 'lodash';
import 'web-animations-js';

// Interfaces
import { Image }              from '../../shared/interfaces/image.interface';

// Helpers
import { IndexedDbHelper }    from '../../shared/helpers/indexed-db.helper';
import { StorageHelper }      from '../../shared/helpers/storage.helper';
import { SynchronizePage } from '../synchronize/synchronize';

@Component({
  selector:    'page-gasselector-phone',
  templateUrl: 'gasselector-phone.html',
  providers:   [LangService, ApplicationService]
})

export class GasselectorPhonePage
{
  countryCode:           string            = null;
  products:              Product[]         = [];
  categories:            Category[]        = [];
  productFamilies:       ProductFamily[]   = [];
  imageFamilyMap:        Map<string, Image> =  new Map();
  searchModel:           any;
  searching:             boolean           = false;;
  isCategory:            boolean           = false;
  isProduct:             boolean           = false;
  isProductFamily:       boolean           = true;
  isBulkFiltered:        boolean           = false;
  beforeSearchState:     number            = 0; //0:productFamily 1:category 2:product
  searchString:          string            = '';
  selectedCategory:      Category          = null;
  selectedProductFamily: ProductFamily     = null;
  imagesPath:            string            = 'assets/images/'; //'https://drive.google.com/uc?id=';
  categoryMap:           Map<string, Product[]>|null  = null;
  productFamilyMap:      Map<string, Category[]>|null = null;
  flyInOutState:         string            = 'in';
  overlayArray:          string []         = ['assets/menu_overlay_4.png', 'assets/menu_overlay_5.png', 'assets/menu_overlay_6.png', 'assets/menu_overlay_7.png', 'assets/menu_overlay_8.png', 'assets/menu_overlay_9.png'];
  overlayIndex:          number            = 0;
  translations           : Translation[]   = [];
  user                   : any             = null;
  currentSearchSize      : number          = 0;
  searchRunning          : boolean         = false;
  waitingLabel           : string          = "Please wait...";

  constructor(public navCtrl            : NavController,
              public loadingCtrl        : LoadingController,
              public toastCtrl          : ToastController,
              public langService        : LangService,
              public applicationService : ApplicationService,
              public menuCtrl           : MenuController,
              public platform           : Platform,
              public translateSerice    : TranslateService,
              private analytics  : GoogleAnalytics)
  {
    this.initTranslations();

    if(StorageHelper.getProducts() === null
      || StorageHelper.getCategories() === null
    )
    {
      this.presentToast('You need to synchronize your data before accessing this feature');
      this.navCtrl.push(SynchronizePage);
      return;
    }

    this.user = StorageHelper.getUser();
    this.getSelectedLang(_ =>
      this.initBulk(true, _ => console.log("init data finished..."))
    );
    }

  ionViewDidLoad()
  {
    this.analytics.trackView("Gasselector");
  }

  initTranslations()
  {
    this.translateSerice.get('PLEASE_WAIT').subscribe(
      value => this.waitingLabel = value
    );
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  translate(value)
  {
    if(value == null)
      return value;

    if(this.translations == null || this.translations.length == 0)
      return value;

    var translate = this.translations.filter(x => this.normalizeKey(x.Name) === this.normalizeKey(value));

    if(translate == null || translate == undefined || translate.length == 0)
      return value;

    return translate[0].Value;
  }

  getImageByName(name: string): string
  {
    name = name.trim().toLocaleLowerCase();
    if(this.imageFamilyMap.has(name))
      return this.imageFamilyMap.get(name).Content;

    return '';
  }

  getImageFallback(name: string): string
  {
    name = name.trim().toLocaleLowerCase();
    if(this.imageFamilyMap.has(name))
    {
      return this.imageFamilyMap.get(name).Content;
    }
    else
    {
      if(this.selectedCategory)
        return this.getImageByName(this.selectedCategory.Name);
    }

    return '';
  }

  async getSelectedLang(callback)
  {
    this.countryCode = await this.applicationService.getSelectedLanguage();
    this.translations = await this.applicationService.getSelectedTranslations();
    callback();
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

 presentLoading()
  {
    let loader = this.loadingCtrl.create({
      content: this.waitingLabel
    });

     return loader;
  }

  getOverlay(index: number)
  {
    return this.overlayArray[index % this.overlayArray.length];
  }

  initProducts(callback)
  {
    const products = StorageHelper.getProducts();
    if(products != null)
    {
      this.products = products;
      this.loadProducts(this.products);
    }
    else
    {
      this.presentToast('Missing products, please synchronize before');
    }

    callback();
  }

  loadProducts(data : Product[])
  {
    if(data == null)
      return;

    if(this.categoryMap == null)
    {
      this.categoryMap = new Map();
      data.forEach(item =>
      {
        if (!this.countryCode
          || item.DisplayedInCountries == null
          || !item.DisplayedInCountries.some(itm => itm === this.countryCode)
        )
          return;

        this.findImageByCategory(item);

        this.products.push(new Product(item));

        var key = this.normalizeKey(item.Category + "_" + item.ProductFamily);

        if(!this.categoryMap.has(key))
          this.categoryMap.set(key, []);

        this.categoryMap.get(key).push(new Product(item));
      });
    }
  }

  initCategories(callback)
  {
    const categories = StorageHelper.getCategories();
    if(categories != null)
    {
      this.categories = categories,
      this.loadCategories(this.categories);
    }
    else
    {
      this.presentToast('Missing categories, please synchronize before');
    }

    callback();
  }

  loadCategories(data)
  {
    if(data == null)
      return;

    if(!this.productFamilyMap)
    {
      this.productFamilyMap = new Map();
      data.forEach(item =>
      {
        this.categories.push(<Category> item);

        var key = this.normalizeKey(item.ProductFamily);

        if(!this.productFamilyMap.has(key))
          this.productFamilyMap.set(key, []);

        this.productFamilyMap.get(key).push(<Category> item);
      });
    }
  }

  initProductFamilies(callback)
  {
    const productFamilies = StorageHelper.getProductFamilies();
    if(productFamilies != null)
    {
      this.productFamilies = productFamilies.sort((a, b) => this.translate(a.Name).localeCompare(b.Name));
    }
    else
    {
      this.presentToast('Missing product families, please synchronize before');
    }

    callback();
  }

  showCategory(item : Category) : boolean
  {

    let cKey = this.normalizeKey(item.Name + "_" + item.ProductFamily);
    let products = this.categoryMap.get(cKey);

    if(!products)
      return false;

    if(products.length > 0)
      return true;

    return false;
  }

  backAction()
  {
    //I am in product list
    if(this.isProduct)
    {
      this.isProduct        = false;
      this.isCategory       = true;
      this.isProductFamily  = false;

      var key;
      if(this.selectedProductFamily)
       key = this.normalizeKey(this.selectedProductFamily.Name);
      else
       key = this.normalizeKey(this.selectedCategory.ProductFamily)

      this.categories = this.productFamilyMap.get(key);
      return;
    }

    //I am in category list
    if(this.isCategory)
    {
      this.isProduct       = false;
      this.isCategory      = false;
      this.isProductFamily = true;

      this.selectedProductFamily = null;

      // Reset catagories back to all of the catagories
      this.initProductFamilies(_ => console.log("ProductFamilies are refreshed"));
      return;
    }

    this.navCtrl.pop({animate: false});
  }

  selectProductFamily(item)
  {
    this.isProduct             = false;
    this.isCategory            = true;
    this.isProductFamily       = false;

    this.selectedProductFamily = item;
    this.searching             = false;

    var key = this.normalizeKey(this.selectedProductFamily.Name);

    if(this.productFamilyMap.has(key))
    {
      this.categories = this.productFamilyMap.get(key);
      this.categories.sort((a, b) => this.translate(a.Name).localeCompare(b.Name));
    }
  }

  selectCategory(item)
  {
    this.isProduct        = true;
    this.isCategory       = false;
    this.isProductFamily  = false;

    this.selectedCategory = item;
    this.searching        = false;

    if(this.selectedProductFamily == null || (this.selectedCategory.ProductFamily != this.selectedProductFamily.Name))
      this.findProducFamilyByCategory(this.selectedCategory.ProductFamily);

    var key = this.normalizeKey(item.Name + "_" + item.ProductFamily);

    if(this.categoryMap.has(key))
    {
      this.products = this.categoryMap.get(key);
      this.products.sort((a, b) => this.translate(a.Name).localeCompare(b.Name));
      return;
    }

    this.products = [];
  }

  normalizeKey(key)
  {
    var normKey = key.replace(/[\t\v\f\r \u00a0\u2000-\u200b\u2028-\u2029\u3000]+/g,'').trim();
    normKey     = normKey.replace(/<\/?[^>]+(>|$)/g, "");

    return normKey.toLowerCase();
  }

  findProducFamilyByCategory(categoryName)
  {
    this.productFamilies.forEach(item =>
    {
      if(item.Name == categoryName)
        this.selectedProductFamily = item;
    });
  }

  selectProduct(item : Product)
  {
    var selItem       = _.cloneDeep(item);

    selItem.ALIGAL          = this.translate(item.ALIGAL);
    selItem.Name            = this.translate(item.Name);
    selItem.NoMap           = this.translate(item.NoMap);
    selItem.WithMap         = this.translate(item.WithMap);
    selItem.Temperature     = this.translate(item.Temperature);
    selItem.LimitingFactors = this.translate(item.LimitingFactors);
    selItem.OxygenLevel     = this.translate(item.OxygenLevel);
    selItem.TypeOfFilm      = this.translate(item.TypeOfFilm);
    selItem.AdditionalInfos = this.translate(item.AdditionalInfos);
    selItem.Country         = this.translate(item.Country);
    selItem.Image           = item.Image;

    this.navCtrl.push(ProductDetailPage, selItem, {animate: true});
  }

  initBulk(spinner, callback)
  {
    let loader  = this.presentLoading();

    if(spinner)
      loader.present();

    setTimeout(_ =>
      this.initProductFamilies(_ =>
        this.initCategories(_ =>
          this.initProducts(async _ =>
          {

            const keys = await IndexedDbHelper.getImageKeys();
            for (const key of keys)
            {
              const image = await IndexedDbHelper.getImage(key);
              this.imageFamilyMap.set(key, image);
            }

            console.log("Bulk init finished");

            if(spinner)
              loader.dismiss();
            else
              this.searchRunning = false;

            callback();
          })
        )
      ),
    1000);
  }

  restoreFilter()
  {
    var key = '';
    switch(this.beforeSearchState)
    {
      case 0:
        this.isCategory      = false;
        this.isProduct       = false;
        this.isProductFamily = true;

        this.initProductFamilies(_ => console.log("Product famiilies are refreshed"));

        break;
      case 1:
        this.isProduct       = false;
        this.isCategory      = true;
        this.isProductFamily = false;

        key                  = this.normalizeKey(this.selectedProductFamily.Name);
        this.categories      = this.productFamilyMap.get(key);
        break;
      case 2:
        this.isProduct       = true;
        this.isCategory      = false;
        this.isProductFamily = false;

        key                  = this.normalizeKey(this.selectedCategory.Name + "_" + this.selectedProductFamily.Name);
        this.products        = this.categoryMap.get(key);
        break;
    }
  }

  searchProductLayout()
  {
    this.searching         = !this.searching;
    this.searchString      = ''
    this.searchRunning     = false;
    if(this.searching)
    {
      this.beforeSearchState = 0;

      //I am in product list
      if(!this.isCategory && this.isProduct)
        this.beforeSearchState = 2;

        //I am in category list
      if(this.isCategory && !this.isProduct)
        this.beforeSearchState = 1;
    }

    this.cleanAllList();

    if(this.searching)
      return;

    this.restoreFilter();
  }

  cleanAllList()
  {
    this.products        = [];
    this.categories      = [];
    this.productFamilies = [];
  }

  getproducts(ev: any)
  {
    if(ev.target.value== null || ev.target.value.length < 3)
    {
      this.searchRunning = false;
      this.cleanAllList();
      this.currentSearchSize = 0;
      return;
    }

    let val = ev.target.value;

    if(this.currentSearchSize == 0)
    {
      this.searchRunning = true;
      this.initBulk(false, _ =>
      {
        this.bulkFilter(val);
        this.currentSearchSize = val.length;
      });
      return;
    }

   //if(val.length > this.currentSearchSize)
   //{
   //  this.searchRunning = false;
   //  this.bulkFilter(val);
   //  this.currentSearchSize = val.length;
   //  return;
   //}

    this.searchRunning = true;
    this.initBulk(false, _ =>
    {
      this.bulkFilter(val);
      this.currentSearchSize = val.length;
    });
  }

  bulkFilter(val)
  {
    var minScore = 5;
    var options =
    {
        pre: "<mark>",
        post: "</mark>",
        extract: entry => entry
    }

    var filtered  = this.filter(val, this.products, options);
    this.products = [];
    filtered.forEach(item =>
    {
      console.info(item.string);
      item.original.Name = item.string;
      this.findImageByCategory(item.original);
      //if(item.score > minScore)
      this.products.push(item.original);
    });

    var filteredCat = this.filter(val, this.categories, options);
    this.categories = [];
    filteredCat.forEach(item =>
    {
      item.original.Name = item.string;
      if(item.score > minScore)
        this.categories.push(item.original);
    });

    var filteredProFam   = this.filter(val, this.productFamilies, options);
    this.productFamilies = [];
    filteredProFam.forEach(item =>
    {
      item.original.Name = item.string;
      if(item.score > minScore)
        this.productFamilies.push(item.original);
    });

    this.isBulkFiltered = true;
  }

  match(pattern, string, opts)
  {
    opts = opts || {};
    var patternIdx = 0
      , result = []
      , len = string.length
      , totalScore = 0
      , currScore = 0
      // prefix
      , pre = opts.pre || ''
      // suffix
      , post = opts.post || ''
      // String to compare against. This might be a lowercase version of the
      // raw string
      , compareString =  opts.caseSensitive && string || string.toLowerCase()
      , ch;

    pattern = opts.caseSensitive && pattern || pattern.toLowerCase();

    // For each character in the string, either add it to the result
    // or wrap in template if it's the next string in the pattern
    for(var idx = 0; idx < len; idx++)
    {
      ch = string[idx];
      if(compareString[idx] === pattern[patternIdx])
      {
        ch = pre + ch + post;

        patternIdx += 1;

        // consecutive characters should increase the score more than linearly
        currScore += 1 + currScore;
      }
      else
        currScore = 0;

      totalScore += currScore;
      result[result.length] = ch;
    }

    // return rendered string if we have a match for every char
    if(patternIdx === pattern.length)
    {
      // if the string is an exact match with pattern, totalScore should be maxed
      totalScore = (compareString === pattern) ? Infinity : totalScore;
      return {rendered: result.join(''), score: totalScore};
    }

    return null;
  };

  filter(pattern, arr, opts)
  {
    if(!arr || arr.length === 0)
      return [];

    if (typeof pattern !== 'string')
      return arr;

    opts = opts || {};
    return arr
      .reduce((prev, element, idx) =>
      {
        var str = element.Name;

        if(opts.extract)
          str = opts.extract(element.Name);

        str = this.translate(str);

        var rendered = this.match(pattern, str, opts);
        if(rendered != null)
        {
          prev[prev.length] =
          {
              string: rendered.rendered
            , score: rendered.score
            , index: idx
            , original: element
          };
        }
        return prev;
      }, [])

      // Sort by score. Browsers are inconsistent wrt stable/unstable
      // sorting, so force stable by using the index in the case of tie.
      // See http://ofb.net/~sethml/is-sort-stable.html
      .sort((a,b) =>
      {
        var compare = b.score - a.score;
        if(compare) return compare;
        return a.index - b.index;
      });
  }

  findImageByCategory(product)
  {
    this.categories.forEach(item =>
    {
      var catkey     = this.normalizeKey(item.Name);
      var prodCatKey = this.normalizeKey(product.Category);
      var pdtfKey    = this.normalizeKey(item.ProductFamily);
      var ppdtfKey   = this.normalizeKey(product.ProductFamily);

      if(catkey == prodCatKey && pdtfKey == ppdtfKey)
        product.Image = item.ImageId;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/gasselector-phone/gasselector-phone.ts